"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

const Label = React.memo(
  React.forwardRef<
    HTMLLabelElement,
    React.LabelHTMLAttributes<HTMLLabelElement>
  >(({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        "block text-sm font-medium text-pretty text-neutral-900 peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className,
      )}
      {...props}
    />
  )),
);
Label.displayName = "Label";

export { Label };
